import React, { useState } from 'react';
import { Dropdown } from 'antd';
import { ChevronDownSmallIcon } from '@/assets/icons/icons';

interface FilterChipProps {
  label: string;
  /** Filled/dark when the filter is narrowed from its default. */
  isActive: boolean;
  renderOverlay: (close: () => void) => React.ReactNode;
}

const FilterChip: React.FC<FilterChipProps> = ({
  label,
  isActive,
  renderOverlay,
}) => {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <Dropdown
      dropdownRender={() => renderOverlay(close)}
      trigger={['click']}
      open={open}
      onOpenChange={setOpen}
      placement='bottom'
      overlayClassName='activity-feed-dropdown-overlay'
      // Unmount the overlay on close so instead of persisting to next open.
      destroyOnHidden
    >
      <button
        type='button'
        className={`zl-btn rounded-full flex-center activity-feed-chip ${
          isActive ? 'zl-btn-clr' : 'zl-btn--10-600'
        }`}
      >
        {label}
        <ChevronDownSmallIcon
          size={8}
          color={isActive ? 'var(--surface-base)' : 'var(--text-primary)'}
        />
      </button>
    </Dropdown>
  );
};

export default FilterChip;
